import _this from '@/main.js';
import store from '@/store';
import axios from 'axios';

import { megError } from '@/utils/message';

// import requestLog from './requestLog';

const http = axios.create({
  timeout: 10000
});

http.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  store.commit('SET_SCREEN_LOADING', true);
  config.headers.bearer = store.getters.jwt;
  return config;
}, error => {
  // 对请求错误做些什么
  console.log('请求错误: ', error);
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // 所有接口先使用http自带的状态码
  
  // 业务码放在meta的code字段
  // 业务码说明放在 meta的 user_message中
  // 具体数据在dataset
  // 2000：请求成功
  // 1008：未登陆
  // 其他直接报错
  
  // 接口数据放在 dataset
  // requestLog(response);
  store.commit('SET_SCREEN_LOADING', false);
  const res = response.data;
  // eslint-disable-next-line eqeqeq
  if (res.meta && res.meta.code != 2000) {
    // 错误的时候
    // eslint-disable-next-line eqeqeq
    if (res.meta.code == 1008) {
      megError('身份已过期，重新登录');
      store.dispatch('logOut')
        .then(() => {
          _this.$router.push('/login');
        });
    }
    // else if (res.code === 405) {
    //   console.log('没有权限');
    // }
    
    megError(res.meta.user_message);
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject('拦截器：error');
  } else {
    // 成功的时候
    return res.dataset;
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default http;
